import { render, staticRenderFns } from "./payment-account.vue?vue&type=template&id=5b30c8b9&scoped=true&"
import script from "./payment-account.vue?vue&type=script&lang=ts&"
export * from "./payment-account.vue?vue&type=script&lang=ts&"
import style0 from "./payment-account.vue?vue&type=style&index=0&id=5b30c8b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30c8b9",
  null
  
)

export default component.exports